import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const statuspage = defineConnector({
  identifier: "statuspage",
  name: "Statuspage",
  tagLine: "Status page and incident comms",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.statuspage\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "OAuth",
      },
    ]),
  steps: [
    {
      title: "Get your Statuspage API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Statuspage dashboard, click your avatar in the bottom left corner and select **API info**. Copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "Your Statuspage API key",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.statuspage.io/v1/pages",
  },
});
